import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ReturnMetricEnum } from '../../../../models/enums/return-metric-enum';

type UnrealizedProfitTooltipContentProps = {
    description: string;
    metrics?: ReturnMetricEnum[];
};

export const UnrealizedProfitTooltipContent: React.FC<UnrealizedProfitTooltipContentProps> = ({
    description,
    metrics = Object.values(ReturnMetricEnum),
}) => {
    const { t } = useTranslation();

    const metricItems = [
        {
            value: ReturnMetricEnum.SimpleReturn,
            label: 'SR',
            description: t('layout.statisticsCard.unrealizedProfit.tooltipMetricSimpleDescription'),
            formula: t('layout.statisticsCard.unrealizedProfit.tooltipMetricSimpleFormula'),
        },
        {
            value: ReturnMetricEnum.TimeWeightedReturn,
            label: 'TWR',
            description: t('layout.statisticsCard.unrealizedProfit.tooltipMetricTimeDescription'),
            formula: t('layout.statisticsCard.unrealizedProfit.tooltipMetricTimeFormula'),
        },
        {
            value: ReturnMetricEnum.MoneyWeightedReturn,
            label: 'MWR',
            description: t('layout.statisticsCard.unrealizedProfit.tooltipMetricMoneyDescription'),
            formula: t('layout.statisticsCard.unrealizedProfit.tooltipMetricMoneyFormula'),
        },
    ].filter((metric) => metrics.includes(metric.value));

    return (
        <div className="text-left">
            <div>{description}</div>
            <hr className="my-[8px] border-0 border-b border-neutral-white/20" />
            <div className="flex flex-col gap-[0.8rem]">
                {metricItems.map((metric) => (
                    <div key={metric.label} className="flex flex-col gap-[0.2rem]">
                        <div className="font-mono text-vsmall font-semibold text-text-inverse">{metric.formula}</div>
                        <div className="text-vsmall text-text-inverse opacity-70">{metric.description}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};
